import React from 'react';
import {
  Container,
  Row,
  Column,
  WideColumn,
  Link,
  Title,
  Text,
  Break,
  Logo,
  BadgeContainer,
  Badge,
  QRSection,
  QRCode,
  AppButtons,
  AppButton,
  InfoSection,
  ColumnTitle,
} from './styles/footer';

export default function Footer({ children, ...restProps }) {
  return <Container {...restProps}>{children}</Container>;
}

Footer.Row = function FooterRow({ children, ...restProps }) {
  return <Row {...restProps}>{children}</Row>;
};

Footer.Column = function FooterColumn({ children, ...restProps }) {
  return <Column {...restProps}>{children}</Column>;
};

Footer.WideColumn = function FooterWideColumn({ children, ...restProps }) {
  return <WideColumn {...restProps}>{children}</WideColumn>;
};

Footer.Link = function FooterLink({ children, ...restProps }) {
  return <Link {...restProps}>{children}</Link>;
};

Footer.Title = function FooterTitle({ children, ...restProps }) {
  return <Title {...restProps}>{children}</Title>;
};

Footer.Text = function FooterText({ children, ...restProps }) {
  return <Text {...restProps}>{children}</Text>;
};

Footer.Break = function FooterBreak({ ...restProps }) {
  return <Break {...restProps} />;
};

Footer.Logo = function FooterLogo({ ...restProps }) {
  return <Logo {...restProps} />;
};

Footer.BadgeContainer = function FooterBadgeContainer({ children, ...restProps }) {
  return <BadgeContainer {...restProps}>{children}</BadgeContainer>;
};

Footer.Badge = function FooterBadge({ ...restProps }) {
  return <Badge {...restProps} />;
};

Footer.QRSection = function FooterQRSection({ children, ...restProps }) {
  return <QRSection {...restProps}>{children}</QRSection>;
};

Footer.QRCode = function FooterQRCode({ ...restProps }) {
  return <QRCode {...restProps} />;
};

Footer.AppButtons = function FooterAppButtons({ children, ...restProps }) {
  return <AppButtons {...restProps}>{children}</AppButtons>;
};

Footer.AppButton = function FooterAppButton({ ...restProps }) {
  return <AppButton {...restProps} />;
};

Footer.InfoSection = function FooterInfoSection({ children, ...restProps }) {
  return <InfoSection {...restProps}>{children}</InfoSection>;
};

Footer.ColumnTitle = function FooterColumnTitle({ children, ...restProps }) {
  return <ColumnTitle {...restProps}>{children}</ColumnTitle>;
};
